import * as types from './types';
import { loading, success, error } from 'State/actions';
import { fetchGeneric } from 'State/generic/actions';
import { getIsDayClosed } from 'Common/GeneralHelper';

export const getReimbursableItems = (mealType, site) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.CEP_BULK_PROCESSING_LOADING_REIMBURSABLE_ITEMS, true)
    );
    try {
      const response = await MPWWebApi.getGeneric(
        `ServedItem/ReimbursableItems/${mealType}/${site}`
      );

      dispatch(
        success(
          types.CEP_BULK_PROCESSING_GET_REIMBURSABLE_ITEMS,
          response.data.Data
        )
      );
    } catch (e) {
      dispatch(error(types.CEP_BULK_PROCESSING_LOAD_ERROR, e));
    }
    dispatch(
      loading(types.CEP_BULK_PROCESSING_LOADING_REIMBURSABLE_ITEMS, false)
    );
  };
};

export const getMealValues = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.CEP_BULK_PROCESSING_LOADING_TOTAL_PARTICIPATION, true)
    );
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `cep/CEPMealValues`,
        model
      );
      dispatch(
        success(types.CEP_BULK_PROCESSING_GET_MEAL_VALUES, response.data.Data)
      );
    } catch (e) {
      dispatch(error(types.CEP_BULK_PROCESSING_LOAD_ERROR, e));
    }
    dispatch(
      loading(types.CEP_BULK_PROCESSING_LOADING_TOTAL_PARTICIPATION, false)
    );
  };
};

export const writeMealValues = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CEP_BULK_PROCESSING_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(`cep/WriteCEPMealValues`, data);
      dispatch(success(types.CEP_BULK_PROCESSING_WRITE_MEALS, true));
    } catch (e) {
      dispatch(error(types.CEP_BULK_PROCESSING_LOAD_ERROR, e));
    }
    dispatch(loading(types.CEP_BULK_PROCESSING_LOADING, false));
  };
};

export const clearWasWritten = () => {
  return success(types.CEP_BULK_PROCESSING_CLEAR_WAS_WRITTEN, false);
};

export const getSitesByFiscalYear = fiscalYear => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CEP_BULK_PROCESSING_SITES_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `cep/ByFiscalYear/${fiscalYear}`
      );
      dispatch(
        success(
          types.CEP_BULK_PROCESSING_GET_CEP_SITES,
          response.data.Data || []
        )
      );
    } catch (e) {
      dispatch(error(types.CEP_BULK_PROCESSING_LOAD_ERROR, e));
    }
    dispatch(loading(types.CEP_BULK_PROCESSING_SITES_LOADING, false));
  };
};

export const clearError = () => {
  return error(types.CEP_BULK_PROCESSING_CLEAR_ERROR, null);
};

export const setIsISPNull = payload => {
  return error(types.CEP_BULK_PROCESSING_SET_ISISPNULL, payload);
};

export const getFiscalYears = () => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.CEP_BULK_PROCESSING_GET_FISCAL_YEARS,
        types.CEP_BULK_PROCESSING_LOADING,
        types.CEP_BULK_PROCESSING_LOAD_ERROR,
        'ControlInfo/FiscalYears'
      )
    );
  };
};

export const getIsDayClosedAction = isDayClosedModel => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CEP_BULK_PROCESSING_LOADING_DAY_CLOSED, true));
      const closed = await getIsDayClosed(isDayClosedModel);
      dispatch(success(types.CEP_BULK_PROCESSING_SET_IS_DAY_CLOSED, closed));
    } catch (e) {
      dispatch(error(types.CEP_BULK_PROCESSING_LOAD_ERROR, e));
    }
    dispatch(loading(types.CEP_BULK_PROCESSING_LOADING_DAY_CLOSED, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/state/processing/actions.js